export const EVENTS_LIST_PAGE_SIZE = 15;

export const EVENTS_VIEW_MODE_COOKIE = 'events-view-mode';
export const EVENTS_VIEW_MODE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
